var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-typing"},[_c('span',{attrs:{"id":"text-typing-line"}}),_c('span',{staticClass:"cursor",class:{'blink': _vm.cursorBlink}},[_vm._v("|")])])}
var staticRenderFns = []

export { render, staticRenderFns }